<template>
  <div>
    <button type="button" class="btn btn-block btn-success" data-toggle="modal" :data-target="`#changeCircuit${macId}`"
      @click="show_input = !show_input">
      選擇線路
    </button>
    <div class="modal fade" :id="`changeCircuit${macId}`" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="changeCircuitTitle"> 選擇線路 </h5>
            <span class="mt-1 mb-0 ml-1">(上限 {{ maxChecked }} 個)</span>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pl-2">
            <table class="table table-hover table-borderless">
              <tbody>
                <tr v-for="( circuit, index ) in meter.bx_circuits" :key="index">
                  <td class="pl-5 col-2">
                    <input type="checkbox" :value="circuit.id" v-model="selected_circuit_ids"
                      :checked="selected_circuit_ids.includes(circuit.id)" :disabled="disableSelect[circuit.id]"
                      :id="'selectCircuit' + macId + circuit.id" @change="checkedLimit">
                  </td>
                  <label :for="'selectCircuit' + macId + circuit.id">
                    <td class="col-4">
                      {{ circuit.alias }}
                    </td>
                  </label>
                  <td class="pt-2 col-6">
                    <chang-circuit-name :show-input="show_input" :circuit-data="circuit"></chang-circuit-name>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" @click="storeCircuitSelect()" class="btn btn-info text-light" data-dismiss="modal">
              確認
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChangCircuitName from './ChangCircuitName.vue';

export default {
  components: { ChangCircuitName },
  data() {
    return {
      show_input: false,
      selected_circuit_ids: [],
      maxChecked: 3,
      disableSelect: {}
    };
  },
  watch: {
    meter() {
      this.initSelectedCircuit();
    },
    deep: true
  },
  computed: {
    meter() {
      return this.$store.getters.selectedMeter;
    },
    macId() {
      let macId = '';
      if (this.meter.bx_mac) {
        macId = this.meter.bx_mac.replace(/:/g, "");
      }
      return macId;
    }
  },
  methods: {
    storeCircuitSelect() {
      this.$store.commit('setSelectedCircuitIds', this.selected_circuit_ids);
    },
    checkedLimit() {
      this.meter.bx_circuits.forEach((circuit) => {
        if (!this.selected_circuit_ids.includes(circuit.id)) {
          this.disableSelect[circuit.id] = this.selected_circuit_ids.length >= this.maxChecked ? true : false;
        }
      })
    },
    initSelectedCircuit() {
      this.selected_circuit_ids = [];
      this.selected_circuit_ids.push(this.meter.bx_circuits[0].id);
      this.storeCircuitSelect();
    }
  }
};
</script>

<style scoped>
.btn {
  font-size: .8rem;
}
</style>
